import { render, staticRenderFns } from "./Colony.vue?vue&type=template&id=46570adc"
import script from "./Colony.vue?vue&type=script&lang=ts"
export * from "./Colony.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports